/* Siluetopía · interacciones de scroll
   Barra de progreso, encabezado compacto, parallax del hero, apariciones
   variadas y líneas de progreso de los pasos. Todo con requestAnimationFrame
   y respetando prefers-reduced-motion. */
(function () {
  const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = document.documentElement;

  // Barra de progreso de lectura
  const barra = document.createElement('div');
  barra.className = 'st-progreso';
  document.body.appendChild(barra);

  // Apariciones automáticas: títulos, tarjetas y bloques de las secciones propias
  const auto = [
    ['.st-h2, .st-catalogo-head .st-h2, .st-eyebrow', 'subir'],
    ['.st-cat-card, .st-historia-card, .st-resena, .st-paso2, .st-comp-fila, .st-confianza li, .st-faq-item, .st-incluye-item', 'subir'],
    ['.st-mision img, .st-cta-final img, .st-estadisticas img', 'zoom'],
  ];
  auto.forEach(([sel, tipo]) => {
    document.querySelectorAll(sel).forEach((el) => {
      if (el.closest('.st-hero') || el.classList.contains('st-reveal')) return;
      if (!el.dataset.stAnim) el.dataset.stAnim = tipo;
    });
  });

  const animables = document.querySelectorAll('[data-st-anim]');
  if (reducido || !('IntersectionObserver' in window)) {
    animables.forEach((el) => el.classList.add('st-anim-on'));
  } else {
    const grupos = new Map();
    const io = new IntersectionObserver((entradas) => {
      entradas.forEach((e) => {
        if (!e.isIntersecting) return;
        const el = e.target;
        const padre = el.parentElement;
        const n = grupos.get(padre) || 0;
        grupos.set(padre, n + 1);
        el.style.transitionDelay = Math.min(n, 6) * 80 + 'ms';
        el.classList.add('st-anim-on');
        io.unobserve(el);
        setTimeout(() => grupos.set(padre, Math.max(0, (grupos.get(padre) || 1) - 1)), 600);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    animables.forEach((el) => io.observe(el));
  }

  // Elementos que reaccionan a la posición del scroll
  const hero = document.querySelector('.st-hero');
  const heroImg = hero && hero.querySelector('.st-hero-img');
  const heroTxt = hero && hero.querySelector('.st-hero-texto');
  const lineas = document.querySelectorAll('[data-st-linea]');
  const header = document.querySelector('.section-header, sticky-header');

  let pendiente = false;
  function pintar() {
    pendiente = false;
    const y = window.scrollY;
    const alto = root.scrollHeight - window.innerHeight;
    barra.style.transform = 'scaleX(' + (alto > 0 ? y / alto : 0) + ')';
    root.classList.toggle('st-scrolleado', y > 40);

    if (!reducido && hero && y < hero.offsetHeight * 1.2) {
      const h = hero.offsetHeight || 1;
      if (heroImg) heroImg.style.transform = 'translate3d(0,' + (y * 0.28) + 'px,0) scale(' + (1.04 + y / h * 0.06) + ')';
      if (heroTxt) {
        heroTxt.style.transform = 'translate3d(0,' + (y * -0.12) + 'px,0)';
        heroTxt.style.opacity = String(Math.max(0, 1 - y / (h * 0.85)));
      }
    }

    lineas.forEach((sec) => {
      const r = sec.getBoundingClientRect();
      const vh = window.innerHeight;
      const p = Math.min(1, Math.max(0, (vh * 0.75 - r.top) / (r.height * 0.85)));
      sec.style.setProperty('--st-p', p.toFixed(3));
      const pasos = sec.querySelectorAll('[data-st-paso]');
      pasos.forEach((paso, i) => paso.classList.toggle('st-paso-activo', p >= (i + 0.35) / pasos.length));
    });
  }
  function alScroll() {
    if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); }
  }
  window.addEventListener('scroll', alScroll, { passive: true });
  window.addEventListener('resize', alScroll);
  pintar();
})();
